import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BoxSystemProps from './BoxSystemProps';
import ClientProvider from './client';
export default createDemo(import.meta.url, BoxSystemProps, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/box/demos/system-props/BoxSystemProps.tsx",
    "fileName": "BoxSystemProps.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/system/Box';\n\nexport default function BoxSystemProps() {\n  return (\n    <Box\n      sx={{\n        height: 200,\n        width: 200,\n        my: 4,\n        display: 'flex',\n        alignItems: 'center',\n        gap: 4,\n        p: 2,\n        border: '2px solid grey',\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      This Box uses MUI System properties through the sx prop.\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 20,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/system/Box';\n\nexport default function BoxSystemProps() {\n  return (\n    <Box\n      sx={{\n        height: 200,\n        width: 200,\n        my: 4,\n        display: 'flex',\n        alignItems: 'center',\n        gap: 4,\n        p: 2,\n        border: '2px solid grey',\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      This Box uses MUI System properties through the sx prop.\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            "      This Box uses MUI System properties through the sx prop."
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 20,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "@mui/system/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
